import React from "react";
import { APP_PREFIX_PATH } from "configs/AppConfig";

export const jobDescriptionRoutes = [
    {
        key: "job-description-create",
        exact: true,
        path: `${APP_PREFIX_PATH}/job-description/create`,
        component: React.lazy(() => import("views/app-views/job-description/pages/JobDescriptionCreate")),
    },
    {
        key: "job-description-edit",
        exact: true,
        path: `${APP_PREFIX_PATH}/job-description/edit/:id`,
        component: React.lazy(() => import("views/app-views/job-description/pages/JobDescriptionEdit")),
    },
    {
        key: "job-description-list",
        exact: true,
        path: `${APP_PREFIX_PATH}/job-description/list`,
        component: React.lazy(() => import("views/app-views/job-description/pages/JobDescriptionList")),
    },
    {
        key: "job-description-detail",
        exact: true,
        path: `${APP_PREFIX_PATH}/job-description/:id`,
        component: React.lazy(() => import("views/app-views/job-description/pages/JobDescriptionDetail")),
    },  
];
